<template>
    <div>
        <div
            v-if="showFirmLogin"
            class="login lawlogin"
            :style="{background: 'url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/firm-login-bg.jpg)', backgroundSize: 'cover', height: loginHeight}"
        >
            <div class="logo lawlogo">
                <img class="law-logo" src="https://lvlin-base.cdn.bcebos.com/pc/common/new-logo.png">
            </div>
            <div class="title-box">
                <div class="title-confirm">百度法行宝 & {{ alreadyLawyerFirm || '北京市盈科律师事务所' }}</div>
                <div class="sub-title-confirm">尊敬的{{ alreadyLawyerName }}律师，欢迎您入驻法行宝</div>
                <div class="middle-container-firm">
                    <pass-firm/>
                </div>
                <div class="sub-bot-title-confirm">
                    如果您在登录过程中遇到任何问题，请联系lvlin_help@baidu.com
                </div>
            </div>
        </div>
        <div
            v-if="showNormalLogin"
            class="login lawlogin"
            :style="{background: 'url( ' + ind[industry].bg + ')', backgroundSize: 'cover', height: loginHeight}"
        >
            <div class="logo lawlogo">
                <img class="law-logo" :src="ind[industry].miniLogo">
            </div>

            <div class="middle-container">
                <div class="login-iframe">
                    <div class="title">
                        百度账号登录
                    </div>
                    <pass/>
                    <div class="pass-notify">为保证完整享受平台各项服务，请务必使用律师本人帐号登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file Login.vue
 * @desc 登录
 * @author baibangyi
*/
import PASS from './pass';
import PASSFirm from './pass-firm';
import {mapState, mapActions} from 'vuex';

export default {
    name: 'Login',
    components: {
        'pass': PASS,
        'pass-firm': PASSFirm
    },
    data() {
        return {
            industry: 'law',
            changedPass: false,
            showNormalLogin: false,
            showFirmLogin: false,
            alreadyLawyerName: '',
            alreadyLawyerFirm: ''
        };
    },
    computed: {
        loginHeight() {
            return {
                height: document.body.clientHeight + 'px'
            };
        },
        ...mapState({
            ind: state => {
                return state.Industry.ind;
            }
        })
    },
    created() {
        const {authToken, name, firm} = this.$route.query;
        if (authToken) {
            this.showFirmLogin = true;
            this.alreadyLawyerName = name || '';
            this.alreadyLawyerFirm = firm || '';
        }
        else {
            this.showNormalLogin = true;
        }
    },
    methods: {
        ...mapActions({
            updateHouseInd: 'Industry/updateHouseInd'
        }),
        changedPassLogin() {
            this.changedPass = !this.changedPass;
        }
    }
};
</script>
<style lang="less" scoped>
    .login {
        min-height: 100vh;
        position: relative;
        background-size: cover;
        width: 100%;
        height: 100%;
        min-width: 1200px;

        &-iframe {
            background: #fff;
            box-shadow: 0 2px 20px 0 rgba(167, 181, 242, .3);
            width: 400px;
            height: 100%;
            padding: 16px 32px;
            box-sizing: border-box;
            position: relative;
            color: #333;
            zoom: 1;

            .pass-notify {
                text-align: center;
                font-size: 14px;
                color: #fff;
                position: absolute;
                bottom: -44px;
                z-index: 9;
                width: 100%;
                left: 0;
            }

            .title {
                font-size: 24px;
                color: #555;
            }
        }
    }

    .logo {
        position: absolute;
        left: 80px;
        top: 20px;
        display: flex;
        align-items: center;

        .logo-img {
            height: 42px;
            width: 42px;
            border-radius: 50%;
            margin-right: 8px;
        }

        .logo-name {
            color: #f00;
        }

        span {
            font-size: 24px;
            color: #fff;
            text-align: center;
            font-weight: 500;
        }

        &-name-red {
            color: #f00;
        }
    }

    .lawlogo {
        top: 24px;
    }

    .law-logo {
        height: 24px;
    }

    .middle-container {
        width: 1120px;
        position: absolute;
        top: 50%;
        left: 50%;
        height: auto;
        min-height: 400px;
        display: flex;
        justify-content: flex-end;
        margin: -250px 0 0 -560px;

        &-firm {
            width: 1120px;
            height: auto;
            min-height: 400px;
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
        }
    }

    .title-box {
        width: 100%;
        min-height: 100vh;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .title-confirm {
        width: 100%;
        font-family: PingFangSC-Medium;
        font-size: 60px;
        color: #1e1f24;
        line-height: 60px;
        text-align: center;
        margin-bottom: 30px;
    }

    .sub-title-confirm {
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: 28px;
        color: #1e1f24;
        line-height: 28px;
        text-align: center;
        margin-bottom: 60px;
    }

    .sub-bot-title-confirm {
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #6a91b6;
        line-height: 18px;
        text-align: center;
    }

    .lawlogin .login-iframe {
        padding-left: 0;
        padding-right: 0;

        .title {
            padding-left: 32px;
        }
    }

    .change-pass {
        padding: 0;
        margin-left: 15px;
    }
</style>